/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unsaved_ChangesInputs */



/**
* | output |
* | --- |
* | "You have unsaved changes. Do you want to cancel?" |
*
* @param {Unsaved_ChangesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const unsaved_changes = /** @type {((inputs?: Unsaved_ChangesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsaved_ChangesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You have unsaved changes. Do you want to cancel?")
	return /** @type {LocalizedString} */ ("Vous avez des modifications non enregistrées. Voulez-vous annuler ?")
});